import { __decorate } from "tslib";
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import noop from 'lodash/noop';
import { getProPrefixCls } from 'choerodon-ui/lib/configure';
import FilterSelect from './FilterSelect';
import ColumnFilter from './ColumnFilter';
import { $l } from '../../locale-context';
let TableFilterBar = class TableFilterBar extends Component {
    renderSuffix() {
        const { prefixCls } = this.props;
        return React.createElement(ColumnFilter, { prefixCls: prefixCls });
    }
    getButtons() {
        const { prefixCls, buttons } = this.props;
        if (buttons.length) {
            return (React.createElement("div", { key: "toolbar", className: `${prefixCls}-toolbar` },
                React.createElement("span", { className: `${prefixCls}-toolbar-button-group` }, buttons)));
        }
    }
    render() {
        const { prefixCls, dataSet, queryDataSet, paramName, placeholder = $l('Table', 'filter_bar_placeholder'), pagination, onQuery = noop, onReset = noop } = this.props;
        const buttons = this.getButtons();
        return [
            buttons,
            pagination,
            React.createElement(FilterSelect, { key: "filter", prefixCls: `${prefixCls}-filter-select`, optionDataSet: dataSet, queryDataSet: queryDataSet, placeholder: placeholder, suffix: this.renderSuffix(), paramName: paramName, onQuery: onQuery, onReset: onReset }),
        ];
    }
};
TableFilterBar.defaultProps = {
    prefixCls: getProPrefixCls('table'),
    paramName: 'params',
};
TableFilterBar = __decorate([
    observer
], TableFilterBar);
export default TableFilterBar;
